import { toneVariant, useCompanionNoun } from '@/utils/personalization'
import MultipleChoiceQuestionPage from '@app-studio-web/ui/pages/MultipleChoiceQuestionPage'
import type { AnswerType } from '@app-studio-web/ui/types'

const answers: AnswerType[] = [
  {
    emoji: '🚫',
    title: 'pages.onboarding.dealbreakers.judgmental',
    value: 'judgmental',
  },
  {
    emoji: '🤖',
    title: 'pages.onboarding.dealbreakers.generic',
    value: 'generic',
  },
  { emoji: '📢', title: 'pages.onboarding.dealbreakers.pushy', value: 'pushy' },
  {
    emoji: '🙉',
    title: 'pages.onboarding.dealbreakers.ignoring',
    value: 'ignoring',
  },
  { emoji: '🌈', title: 'pages.onboarding.dealbreakers.toxic', value: 'toxic' },
  {
    emoji: '📝',
    title: 'pages.onboarding.dealbreakers.forgetful',
    value: 'forgetful',
  },
]

export default function DealbreakersQuestionPage() {
  const noun = useCompanionNoun()

  return (
    <MultipleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.dealbreakers.title"
      subtitle={toneVariant('pages.onboarding.dealbreakers.subtitle')}
      translationInterpolation={{ noun }}
    />
  )
}
